import React, { useContext, useState, useRef, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    CircularProgress,
    IconButton,
    MenuItem,
    Tab,
    Tabs,
    Tooltip,
    Typography,
    tabsClasses,
    useTheme,
    useMediaQuery,
} from '@mui/material';

import {
    Close,
    DocumentScanner,
    FileUpload,
    MoreVert,
    PlayCircleOutline,
    Upload,
} from '@mui/icons-material';

import PermissionGuard from '../../contexts/PermissionContext';
import ProjectContext from '../../contexts/ProjectContext';

import ControlBar from '../structure/ControlBar';
import ControlButton from '../structure/ControlButton';
import ControlDivider from '../structure/ControlDivider';
import BaseMenu from '../rightclicks/BaseMenu';
import UploadIllusionMobile from '../dialog/UploadIllusionMobile';
import UploadIllusionEDLDialog from '../dialog/UploadIllusionEDLDialog/UploadIllusionEDLDialog';
import {useFetch} from '../../components/auth/useFetch';


export default function IllusionViewMenuBar(props) {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const isSm = useMediaQuery(theme.breakpoints.down('md'))
    const isMd = useMediaQuery(theme.breakpoints.down('lg'))
    const isLg = useMediaQuery(theme.breakpoints.down('xl'))
    const fetchWithAuth = useFetch()

    const {
        edlName,
        isQTUploading,
        qt,
        qtUploadProgress,
        selectedPlates = [],
        setEdlName,
        setIsResubmitDialogOpen,
        setQT,
        setTabs,
        setValue,
        tabs,
        uploadQTFile,
        value,
    } = props
    const fileBrowserRef = useRef(null)
    const { isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);

    const [vendors, setVendors] = useState([])
    const [pullTypes, setPullTypes] = useState([])
    const [openUploadDialog, setOpenUploadDialog] = useState(false)
    const [rows, setRows] = React.useState([])
    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null)

    const resubmitLabel = selectedPlates.length === 0
        ? 'Resubmit'
        : selectedPlates.length === 1
            ? `Resubmit ${selectedPlates[0]}`
            : `Resubmit ${selectedPlates.length} plates`;

    useEffect(() => {
        if (!isAuthenticated) return;
        fetchVendors();
        fetchPullTypes();
    }, [isAuthenticated]);
    
    const fetchVendors = async () => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/vendors`, {
                headers: { 'X-Project-ID': projectContext?.project_db }
            });
            const res = await response.json();
            setVendors(res.map(v => ({
                name: v.name,
                value: v.short,
                email: v.email
            })));
        } catch (e) {
            console.error(e);
        }
    };

    const fetchPullTypes = async () => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/pulltypes`, {
                headers: { 'X-Project-ID': projectContext?.project_db }
            });
            const res = await response.json();
            setPullTypes(res.map(value => ({
                name: value?.name,
                value: value?.name,
            })));
        } catch (e) {
            console.error(e);
        }
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setEdlName(tabs[newValue])
    };

    const handleClose = (e, tabIndex) => {
        e.stopPropagation()

        if(tabIndex === value){
            setValue((prevValue) => (prevValue > 0 ? prevValue - 1 : 0));
        }
        const newTabs = tabs.filter((_, index) => index !== tabIndex);
        setTabs(newTabs)
    }

    const fileDialog = (e) => {
        setOpenUploadDialog((prevState) => !prevState)
    }

    const generateALE = () => {
        var myHeaders = new Headers()
        myHeaders.append("Content-Type", "application/json")
        var selected_clips = []
        for(var i=0; i<rows.length; i++){
            selected_clips.push(rows[i]['clipname'])
        }
        const raw = JSON.stringify(selected_clips)
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }
        downloadALE(requestOptions)
    }

    const downloadALE = (requestOptions) => {
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/edlale/?edl_name=${edlName}`, requestOptions)
        .then((response) => response.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${edlName}.ale`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        })
    }

    const clicked = () => {
        setOpenUploadDialog(!openUploadDialog)
    }

    const handleMoreMenuClick = (event) => {
        setMoreMenuAnchorEl(event.currentTarget)
    }

    const handleMoreMenuClose = () => {
        setMoreMenuAnchorEl(null)
    }

    const openFileBrowser = () => {
        handleMoreMenuClose()
        fileBrowserRef.current.click()
    }
    


    return (

        <React.Fragment>
            <ControlBar>
                <Box sx={{ 
                    maxWidth: '60vw' , 
                }}>
                    <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                        }}
                    >
                        {tabs.map((tab, index) => (
                            <Tab 
                                key={index}
                                label={
                                    <Box
                                        display={'flex'}
                                        height={'20px'}
                                        alignItems={'center'}
                                    >
                                        {tab}
                                        {index > 0 && (<IconButton

                                            onClick={(e) => handleClose(e, index)}
                                            sx={{
                                                color: 'grey',
                                                '&:hover': {
                                                    color: 'white'
                                                }
                                            }}
                                        >
                                            <Close sx={{ 
                                                fontSize: {sx: '20px', md: '14px'}
                                            }}/>
                                        </IconButton>)}
                                    </Box>
                                }
                                style={{
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    color: value === index ? 'rgb(255, 255, 255)' : 'rgb(150, 150, 150)'
                                }}
                            />
                        ))}
                    </Tabs>
                </Box>

                <ControlDivider />
                { 
                isSm 
                ?
                <ControlButton
                    title="More"
                    clicked={handleMoreMenuClick}
                >
                    <MoreVert />
                </ControlButton>
                :
                <React.Fragment>
                    <PermissionGuard permission={['write:illusion']}>
                        <ControlButton
                            title='Upload File'
                            disabled={value > 0}
                            clicked={fileDialog}>
                            <FileUpload style={{fill: 'white'}} />
                        </ControlButton>

                        <ControlDivider />
                    </PermissionGuard>

                    <PermissionGuard permission={['write:illusion']}>
                        <ControlButton
                            title={resubmitLabel}
                            disabled={selectedPlates.length === 0 || value === 0}
                            clicked={() => setIsResubmitDialogOpen(true)}>
                                <PlayCircleOutline style={{fill: "white"}} />
                        </ControlButton>
                    </PermissionGuard>
                    <PermissionGuard permission={['read:illusion', 'write:deliverables']}>
                        <ControlButton
                            title="Download ALE"
                            disabled={value === 0}
                            clicked={generateALE}>
                                <DocumentScanner style={{fill: "white"}} />
                        </ControlButton>
                    </PermissionGuard>
                    {isQTUploading && (
                        <Tooltip
                            title={qt === null ? 'Nothing Uploading' : `${qt?.name ??  'File'} upload in progress`}
                        >
                            <Box
                                display='inline-flex'
                                position='relative'
                            >
                                <CircularProgress
                                    size={30}
                                    variant='determinate'
                                    value={qtUploadProgress}
                                    sx={{
                                        color: 'rgb(71,132,96)'
                                    }}
                                />
                                <Box
                                    sx={{
                                        top: 0,
                                        left: 0,
                                        bottom: 0,
                                        right: 0,
                                        position: 'absolute',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '8px'
                                        }}
                                    >
                                        {`${Math.round(qtUploadProgress)}%`}
                                    </Typography>
                                </Box>
                            </Box>
                        </Tooltip>
                    )}
                    <UploadIllusionEDLDialog
                        isQTUploading={isQTUploading}
                        open={openUploadDialog}
                        qt={qt}
                        setOpen={clicked}
                        setQT={setQT}
                        uploadQTFile={uploadQTFile}
                        vendors={vendors}
                        pullTypes={pullTypes}
                    />
                </React.Fragment>
                }
            </ControlBar>

            <BaseMenu
                handleMenuClose={handleMoreMenuClose}
                menuAnchorEl={moreMenuAnchorEl}
            >
                <MenuItem
                    onClick={openFileBrowser}
                >
                    <Upload style={{fill: "white"}} />
                    Upload File
                </MenuItem>
                {selectedPlates.length > 0 && <MenuItem
                    onClick={() => setIsResubmitDialogOpen(true)}
                    disabled={value === 0}>
                    {/* <FilterAltOff style={{ fill: "white" }} /> */}
                    <PlayCircleOutline style={{ fill: "white" }} />
                    {resubmitLabel}
                </MenuItem>}
                <MenuItem
                    onClick={generateALE}
                    disabled={value === 0}
                >
                    <DocumentScanner style={{ fill: "white" }} />
                    Download ALE
                </MenuItem>
            </BaseMenu>
            <UploadIllusionMobile
                fileBrowserRef={fileBrowserRef}
            />
        </React.Fragment>
    );
}